{
  "name": "deleteme-frontend",
  "version": "1.0.2",
  "scripts": {
    "ng": "ng",
    "start:members": "ng serve members --host=0.0.0.0",
    "start:members:deleteme": "ng serve members --configuration=development-deleteme --host=0.0.0.0",
    "start:friskas": "ng serve friskas --host=0.0.0.0",
    "start:admin": "ng serve admin",
    "build": "ng build",
    "build:members": "ng build members --configuration=production",
    "build:members:deleteme": "ng build members --configuration=production-deleteme",
    "build:friskas": "ng build friskas --configuration=production",
    "build:admin": "ng build admin --configuration=production",
    "build:members:dev": "ng build members --configuration=dev",
    "build:members:demo": "ng build members --configuration=demo",
    "build:admin:dev": "ng build admin --configuration=dev",
    "build:admin:demo": "ng build admin --configuration=demo",
    "watch": "ng build --watch --configuration=development",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^18.2.0",
    "@angular/common": "^18.2.0",
    "@angular/compiler": "^18.2.0",
    "@angular/core": "^18.2.0",
    "@angular/forms": "^18.2.10",
    "@angular/platform-browser": "^18.2.0",
    "@angular/platform-browser-dynamic": "^18.2.0",
    "@angular/router": "^18.2.0",
    "@ngx-formly/core": "^6.3.10",
    "@primeng/themes": "^18.0.2",
    "@types/luxon": "^3.4.2",
    "@types/signature_pad": "^2.3.6",
    "chart.js": "^4.5.0",
    "class-transformer": "^0.5.1",
    "countries-list": "^3.1.1",
    "flag-icons": "^7.2.3",
    "google-libphonenumber": "^3.2.38",
    "html2canvas-pro": "^1.5.11",
    "luxon": "^3.5.0",
    "marked": "^18.0.5",
    "ngx-permissions": "^19.0.0",
    "ngx-stripe": "^18.1.0",
    "posthog-js": "^1.364.7",
    "primeicons": "^7.0.0",
    "primeng": "^18.0.2-patch.1",
    "quill": "^2.0.3",
    "rxjs": "~7.8.0",
    "signature_pad": "^5.0.4",
    "tailwindcss-primeui": "^0.3.4",
    "tslib": "^2.3.0",
    "zone.js": "~0.14.10"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^18.2.11",
    "@angular/cli": "^18.2.11",
    "@angular/compiler-cli": "^18.2.0",
    "@ngx-formly/schematics": "^6.3.10",
    "@types/google-libphonenumber": "^7.4.30",
    "@types/jasmine": "~5.1.0",
    "autoprefixer": "^10.4.20",
    "jasmine-core": "~5.2.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "ng-packagr": "^18.2.0",
    "postcss": "^8.4.47",
    "tailwindcss": "^3.4.14",
    "typescript": "~5.5.2"
  }
}
